// extracted by mini-css-extract-plugin
export default {"banner":"banner--Hb83q","bannerText":"bannerText--RcYE9","bannerActionText":"bannerActionText--xEwvU","bannerIcon":"bannerIcon--VlEht","bannerClose":"bannerClose--cpNUy"};